import React, { useRef } from 'react';
import { motion } from 'framer-motion';

import {
  BackupCard,
  BackupRow,
  BackupMeta,
  BackupNotice,
  ExportButton,
  ReminderButton,
  DangerButton,
  CheckInButton,
  SectionTitle,
} from '../../pages/results/resultsStyles';

const ResultsBackupSection = ({
  pendingBackup,
  pendingBackupSummary,
  backupError,
  backupMessage,
  onExport,
  onChooseImport,
  onImportSelected,
  onRestore,
  onDeleteAll,
  variants,
}) => {
  const importFileRef = useRef(null);

  const handleChooseImport = () => {
    onChooseImport();
    if (importFileRef.current) {
      importFileRef.current.value = '';
      importFileRef.current.click();
    }
  };

  return (
    <BackupCard as={motion.section} variants={variants} aria-labelledby="backup-heading" id="backup-heading">
      <SectionTitle id="backup-heading" as="h2">
        Private backup
      </SectionTitle>
      <p style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>
        Export or restore your results and check-ins as a JSON file on this device. You can also delete everything
        stored locally (GDPR erasure on this device).
      </p>
      <BackupRow>
        <ExportButton type="button" onClick={onExport} whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
          Download backup
        </ExportButton>
        <ReminderButton type="button" onClick={handleChooseImport} whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
          Import backup
        </ReminderButton>
        <DangerButton type="button" onClick={onDeleteAll} whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
          Delete all local data
        </DangerButton>
        {pendingBackup && (
          <CheckInButton type="button" onClick={onRestore} whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
            Restore
          </CheckInButton>
        )}
        <input
          ref={importFileRef}
          type="file"
          accept="application/json"
          onChange={onImportSelected}
          style={{ display: 'none' }}
          aria-hidden="true"
          tabIndex={-1}
        />
      </BackupRow>
      {pendingBackupSummary && (
        <BackupMeta>
          Backup: {pendingBackupSummary.resultsHistoryCount} runs, {pendingBackupSummary.checkInsCount} check-ins.
        </BackupMeta>
      )}
      {backupError && (
        <BackupNotice role="alert" style={{ color: '#f87171' }}>
          {backupError}
        </BackupNotice>
      )}
      {backupMessage && !backupError && (
        <BackupNotice role="status" style={{ color: 'var(--type-accent, var(--primary-color))' }}>
          {backupMessage}
        </BackupNotice>
      )}
    </BackupCard>
  );
};

export default ResultsBackupSection;
